import Markdown from "react-markdown";
import { styled } from "styled-components";
import Layout from "../components/Layout";
import { Link, useParams } from "react-router-dom";
import Moment from "react-moment";
import remarkGfm from "remark-gfm";
import posts from "../posts.json";
import rehypeRaw from "rehype-raw";
import Placeholder from "../assets/images/placeholder-big.jpg"
import AuthorBox from "./Author";

function BlogPost() {
  const params = useParams();
  const post = posts.find((p) => p.alias.trim() === params.id);
  const hero = post.fields.images && post.fields.images.banner ? `data:image/jpg;base64, ${post.fields.images.banner}`:Placeholder;
  const photo = post.fields.images && post.fields.images.author ? `data:image/jpg;base64, ${post.fields.images.author}`:"";
  return (
    <Layout>
      <BlogWrapper>
        <Content className="layoutWrapper">
          <Link to="/blogs">
            <BackButton>&laquo; Return to All Blogs</BackButton>
          </Link>
          <H2>{post.title}</H2>
          <PDate>
            <Moment format="MMMM D, YYYY">{post.modifiedWhen}</Moment>
          </PDate>          
          <Social>
          <AuthorBox name={post.createdBy} photo={photo} />
          </Social>
          <BlogHero>
            <img src={hero} alt="" />
          </BlogHero>
          <Markdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
            {post.fields.fullDescription}
          </Markdown>
        </Content>
      </BlogWrapper>
    </Layout>
  );
}
export default BlogPost;

const BlogWrapper = styled.section``;
const BlogHero = styled.section`
  min-height: 300px;
  display: flex;
  overflow: hidden;
  justify-content: center;
  margin-bottom: 30px;
`;
const Content = styled.section`
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  p {
    line-height: 30px;
    margin-bottom: 20px;
  }
  ul, li {
    list-style: auto;
  }
  a {
    text-decoration: none;
    color: rgb(4, 115, 234);
    &:hover {
      text-decoration: underline;
    }
  }
`;

const H2 = styled.h2`
  font-size: 50px;
  color: #212121;
`;

const PDate = styled.p`
  font-weight: bold;
  font-size: 13px;
`;

const BackButton = styled.button`
  background: #eee;
  border-radius: 18px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  height: 30px;
  cursor: pointer;
  padding: 0 20px;
  &:hover {
    background: #aaa;
    color: #fff;
  }
`;

const Social = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
